export default "__VITE_ASSET__8fa351a3__"